/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Slogan_1_PrefixInputs */



/**
* | output |
* | --- |
* | "AI without" |
*
* @param {Auth_Slogan_1_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_slogan_1_prefix = /** @type {((inputs?: Auth_Slogan_1_PrefixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Slogan_1_PrefixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("KI ohne")
	return /** @type {LocalizedString} */ ("AI without")
});